module.exports = __webpack_public_path__ + "static/media/TopDelivery2_4.d0f63fdf.png";